// register global Modal helper
window.Modal = {
    opening: false,
    trigger: null,
    open: function (modal, data = {}, event = null) {
        // ignoruj kolejne kliknięcia dopóki żądanie otwarcia nie przejdzie
        if (this.opening) {
            return;
        }
        this.opening = true;

        this.trigger = (event ?? window.event)?.target?.closest('button, a') ?? null;
        if (this.trigger) {
            this.trigger.setAttribute('data-loading', 'true');
            // zdejmij focus z triggera, żeby Enter potwierdzający modal nie klikał go ponownie
            this.trigger.blur();
        }

        Livewire.dispatch('openModal', {modal: modal, data: data});
    },
    release: function () {
        this.opening = false;
        if (this.trigger) {
            this.trigger.removeAttribute('data-loading');
            this.trigger = null;
        }
    },
    close: function (id) {
        const modal = document.querySelector('[data-modal-id="' + id + '"]');
        if (!modal || modal.classList.contains('modal-closing')) {
            return;
        }

        // odegraj animację wyjścia i dopiero potem usuń modal po stronie Livewire,
        // inaczej odpowiedź serwera wycina element z DOM zanim animacja się skończy
        let dispatched = false;
        const dispatch = () => {
            if (dispatched) {
                return;
            }
            dispatched = true;
            Livewire.dispatch('closeModal', {id: id});
        };

        modal.classList.add('modal-closing');
        // animationend bąbelkuje z dzieci (ikony, spinnery) - reaguj tylko na własną animację
        modal.addEventListener('animationend', (e) => {
            if (e.target === modal && e.animationName === 'modal-backdrop-out') {
                dispatch();
            }
        });
        // zabezpieczenie gdyby animationend nie doszło (np. prefers-reduced-motion)
        setTimeout(dispatch, 300);
    },
}

// close top modal using Esc key
document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
        const modalManager = document.getElementById('modal-manager');
        const modals = modalManager?.querySelectorAll('.modal:not(.modal-closing)') ?? [];
        const lastModal = modals[modals.length - 1];
        if (lastModal) {
            Modal.close(lastModal.getAttribute('data-modal-id'));
        }
    }
});

// triggering media modals
document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-media-modal-trigger]');
    if (!trigger) {
        return;
    }
    const data = {
        parentId: trigger.getAttribute('id')
    };
    const fileId = trigger.getAttribute('data-media-modal-trigger');
    if (fileId) {
        data.file = fileId;
    }

    Modal.open('file::components.media-modal', data, event);
});

document.addEventListener('livewire:init', () => {

    // clickable table rows
    function isInteractiveElement(target) {
        return !!target.closest('button, a, input, textarea, select, label');
    }

    function getRowTarget(event) {
        const table = event.target.closest('.table');
        if (!table) return null;

        if (isInteractiveElement(event.target)) return null;

        const tr = event.target.closest('tr');
        if (!tr) return null;

        const target = tr.querySelector('.clickable-target');
        if (!target) return null;

        return target;
    }

    function openTarget(target, newTab = false) {
        const href = target.getAttribute('href');
        const url = (href && !href.startsWith('javascript:')) ? href : target.dataset.href;

        if (url) {
            if (newTab) {
                window.open(url, '_blank', 'noopener');
            } else {
                window.location.href = url;
            }
            return;
        }

        target.click();
    }

// blokuje zaznaczanie tekstu / komórki przy Ctrl/Cmd i middle click
    document.addEventListener('mousedown', (event) => {
        const target = getRowTarget(event);
        if (!target) return;

        const isCtrlClick = event.ctrlKey || event.metaKey;
        const isMiddleClick = event.button === 1;

        if (isCtrlClick || isMiddleClick) {
            event.preventDefault();
        }
    });

// zwykły click + Ctrl/Cmd click
    document.addEventListener('click', (event) => {
        const target = getRowTarget(event);
        if (!target) return;

        const openInNewTab = event.ctrlKey || event.metaKey;

        event.preventDefault();
        openTarget(target, openInNewTab);
    });

// środkowy przycisk
    document.addEventListener('auxclick', (event) => {
        if (event.button !== 1) return;

        const target = getRowTarget(event);
        if (!target) return;

        event.preventDefault();
        openTarget(target, true);
    });

});

// Przytrzymanie Shift przełącza globalnie wszystkie kolumny akcji grida
// z widoku "..." na płaską listę przycisków (patrz _grid-view.scss).
(function () {
    let shiftActive = false;

    function setShiftActive(active) {
        if (shiftActive === active) return;
        shiftActive = active;

        if (active) {
            document.querySelectorAll('.grid-action-buttons__compact .dropdown-menu.show').forEach((menu) => {
                const toggle = menu.previousElementSibling;
                bootstrap.Dropdown.getInstance(toggle)?.hide();
            });
        }

        document.body.classList.toggle('grid-action-buttons-expanded', active);
    }

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Shift') setShiftActive(true);
    });

    document.addEventListener('keyup', (event) => {
        if (event.key === 'Shift') setShiftActive(false);
    });

    window.addEventListener('blur', () => setShiftActive(false));
})();

window.addEventListener('popstate', function () {
    const url = new URL(window.location);
    const tabId = url.searchParams.get('tab');

    if (tabId) {
        const triggerEl = document.querySelector(`[data-bs-target="#tab-${tabId}"]`);
        if (triggerEl) {
            new bootstrap.Tab(triggerEl).show();
            return;
        }
    }

    // fallback: tab domyślny
    const defaultTab = document.querySelector('[data-tab-default]');
    if (defaultTab) {
        new bootstrap.Tab(defaultTab).show();
    }
});

window.copyToClipboard = async function (textToCopy) {
    if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(textToCopy);
        toastr['success']('Skopiowano do schowka.', null, {
            positionClass: 'toast-bottom-right',
            progressBar: false,
            timeOut: 6000,
            tapToDismiss: false,
            closeButton: true
        });
    } else {
        const textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        textArea.style.position = "absolute";
        textArea.style.left = "-999999px";
        document.body.prepend(textArea);
        textArea.select();
        try {
            document.execCommand('copy');
            toastr['success']('Skopiowano do schowka.', null, {
                positionClass: 'toast-bottom-right',
                progressBar: false,
                timeOut: 6000,
                tapToDismiss: false,
                closeButton: true
            });
        } catch (error) {
            toastr['error'](error, null, {
                positionClass: 'toast-bottom-right',
                progressBar: false,
                timeOut: 6000,
                tapToDismiss: false,
                closeButton: true
            });
        } finally {
            textArea.remove();
        }
    }
}

window.setQueryParam = function(key, value) {
    const url = new URL(window.location);
    url.searchParams.set(key, value);
    window.history.pushState({}, '', url);
}

window.initTooltips = function (target = document) {
    target.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
        // Dispose + recreate so the instance re-syncs with the title/markup that
        // Livewire re-rendered (it re-adds the native title and drops Bootstrap's
        // data-bs-original-title). The disposed-callback crash is neutralised by
        // the _queueCallback guard in bootstrap.js.
        const instance = bootstrap.Tooltip.getInstance(el);
        if (instance) {
            try { instance.dispose(); } catch (e) {}
        }
        new bootstrap.Tooltip(el);
    });
}

window.closeTooltips = function () {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
        const instance = bootstrap.Tooltip.getInstance(el);
        if (instance) {
            try { instance.hide(); } catch (e) {}
        }
    });
}

window.disposeTooltips = function (target = document) {
    target.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
        const instance = bootstrap.Tooltip.getInstance(el);
        if (instance) {
            try { instance.dispose(); } catch (e) {}
        }
    });
}

function playIconAnimation(el, animClass, oppositeClass) {
    // Drop the opposite direction first so a rapid A -> B -> A navigation never
    // leaves both the fill-in and drain-out classes on the same element.
    el.classList.remove(oppositeClass);
    el.classList.add(animClass);
    el.addEventListener('animationend', () => {
        el.classList.remove(animClass);
    }, { once: true });
}

// Animate the icon fill only when the active section/tab actually changes: the
// newly active icon fills in (far -> fas), the previously active one drains back
// out (fas -> far). Same-section navigation and the first page load leave the
// same icon active, so nothing animates.
function animateIconChange(itemSelector, keyAttr, animClass, deanimClass, state) {
    const items = Array.from(document.querySelectorAll(itemSelector));
    const active = items.find((el) => el.classList.contains('active')) ?? null;
    const key = active ? active.getAttribute(keyAttr) : null;

    if (state.last !== null && key !== state.last) {
        if (active) {
            playIconAnimation(active, animClass, deanimClass);
        }
        const previous = items.find((el) => el.getAttribute(keyAttr) === state.last);
        if (previous && previous !== active) {
            playIconAnimation(previous, deanimClass, animClass);
        }
    }

    state.last = key;
}

const railIconState = { last: null };
const mobileTabIconState = { last: null };
const mobileTabIndicatorState = { x: null, from: null };

function setMobileTabIndicator(indicator, x, animate) {
    if (animate) {
        indicator.style.setProperty('--mobile-tab-indicator-x', x + 'px');

        return;
    }

    // .is-static zdejmuje transition, więc skok na pozycję nie jest animowany.
    // Odczyt offsetWidth wymusza reflow - bez niego przeglądarka scaliłaby
    // dodanie i usunięcie klasy w jedno przeliczenie stylów i mimo wszystko
    // animowała.
    indicator.classList.add('is-static');
    indicator.style.setProperty('--mobile-tab-indicator-x', x + 'px');
    void indicator.offsetWidth;
    indicator.classList.remove('is-static');
}

// Wskaźnik aktywnej zakładki (pasek nad ikonką) przejeżdża między zakładkami
// zamiast przeskakiwać. Nowy DOM po wire:navigate nie zna poprzedniej pozycji,
// więc bierzemy ją z modułowego stanu: najpierw ustawiamy wskaźnik tam bez
// animacji, a w kolejnej ramce puszczamy przejazd do środka nowej zakładki.
// Pierwsze wejście i nawigacja w obrębie tej samej zakładki ustawiają pozycję
// od razu.
window.refreshMobileTabIndicator = function (animate = true) {
    const bar = document.querySelector('.mobile-tab-bar');
    const indicator = bar ? bar.querySelector('.mobile-tab-bar-indicator') : null;
    if (!indicator) {
        return;
    }

    const active = bar.querySelector('.mobile-tab-bar-item.active');
    if (!active) {
        indicator.classList.remove('is-visible');
        mobileTabIndicatorState.x = null;

        return;
    }

    if (!active.offsetWidth) {
        return;
    }

    const target = active.offsetLeft + active.offsetWidth / 2;
    const previous = mobileTabIndicatorState.x;
    const slide = animate && previous !== null && Math.abs(previous - target) > 0.5;

    mobileTabIndicatorState.x = target;
    indicator.classList.add('is-visible');

    if (!slide) {
        // Don't re-apply the same position - .is-static would cut off a slide
        // resumed after the DOM swap (resumeMobileTabAnimations).
        if (!animate || indicator.style.getPropertyValue('--mobile-tab-indicator-x') !== target + 'px') {
            setMobileTabIndicator(indicator, target, false);
        }

        return;
    }

    mobileTabIndicatorState.from = previous;
    setMobileTabIndicator(indicator, previous, false);
    requestAnimationFrame(() => setMobileTabIndicator(indicator, target, true));
};

window.refreshIconAnimations = function () {
    animateIconChange('.sidebar-rail-nav .sidebar-rail-link', 'data-section-key', 'rail-animating', 'rail-deanimating', railIconState);
    animateIconChange('.mobile-tab-bar-item', 'data-tab-key', 'tab-animating', 'tab-deanimating', mobileTabIconState);
    window.refreshMobileTabIndicator();
}

// Switch the tab right on click, before wire:navigate gets the response - the
// bar has to react like a native app, only the content may load afterwards.
// After livewire:navigated the server renders the same active tab, so icon and
// indicator state already match and nothing animates twice. If the server
// marks a different tab as active, the post-navigation refresh corrects it.
document.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
    }

    const item = event.target.closest('.mobile-tab-bar-item');
    if (!item || item.classList.contains('active')) {
        return;
    }

    item.parentElement.querySelectorAll('.mobile-tab-bar-item.active').forEach((el) => el.classList.remove('active'));
    item.classList.add('active');

    animateIconChange('.mobile-tab-bar-item', 'data-tab-key', 'tab-animating', 'tab-deanimating', mobileTabIconState);
    window.refreshMobileTabIndicator();
}, true);

// wire:navigate swaps the whole <body>, so tab bar animations started on click
// would be cut off whenever the response arrives before they finish. Right
// before the swap we capture their progress, then replay the same animations
// on the new DOM and seek them to that point.
function captureMobileTabAnimations() {
    const bar = document.querySelector('.mobile-tab-bar');
    if (!bar) {
        return null;
    }

    const icons = [];
    bar.querySelectorAll('.mobile-tab-bar-item.tab-animating, .mobile-tab-bar-item.tab-deanimating').forEach((item) => {
        const running = item.getAnimations({ subtree: true });
        if (running.length) {
            icons.push({
                key: item.getAttribute('data-tab-key'),
                className: item.classList.contains('tab-animating') ? 'tab-animating' : 'tab-deanimating',
                currentTime: running[0].currentTime,
            });
        }
    });

    const indicator = bar.querySelector('.mobile-tab-bar-indicator');
    const slide = indicator ? indicator.getAnimations().find((animation) => animation.transitionProperty === 'transform') : null;

    return {
        icons,
        indicatorTime: slide && mobileTabIndicatorState.from !== null ? slide.currentTime : null,
    };
}

function resumeMobileTabAnimations(captured) {
    const bar = document.querySelector('.mobile-tab-bar');
    if (!bar) {
        return;
    }

    captured.icons.forEach(({ key, className, currentTime }) => {
        const item = bar.querySelector('.mobile-tab-bar-item[data-tab-key="' + key + '"]');
        if (!item) {
            return;
        }
        playIconAnimation(item, className, className === 'tab-animating' ? 'tab-deanimating' : 'tab-animating');
        item.getAnimations({ subtree: true }).forEach((animation) => {
            animation.currentTime = currentTime;
        });
    });

    const indicator = bar.querySelector('.mobile-tab-bar-indicator');
    const active = bar.querySelector('.mobile-tab-bar-item.active');
    const target = mobileTabIndicatorState.x;
    if (captured.indicatorTime === null || !indicator || !active || active.offsetLeft + active.offsetWidth / 2 !== target) {
        return;
    }

    indicator.classList.add('is-visible');
    setMobileTabIndicator(indicator, mobileTabIndicatorState.from, false);
    setMobileTabIndicator(indicator, target, true);
    indicator.getAnimations()
        .filter((animation) => animation.transitionProperty === 'transform')
        .forEach((animation) => {
            animation.currentTime = captured.indicatorTime;
        });
}

document.addEventListener('livewire:navigating', (event) => {
    const captured = captureMobileTabAnimations();
    if (captured && event.detail && event.detail.onSwap) {
        event.detail.onSwap(() => resumeMobileTabAnimations(captured));
    }
});

// Zmiana szerokości okna (obrót, zwijanie paska adresu) przesuwa środki
// zakładek - repozycjonuj bez animacji, w rAF, żeby nie czytać layoutu na
// każdym zdarzeniu resize.
let mobileTabIndicatorFrame = null;
window.addEventListener('resize', () => {
    if (mobileTabIndicatorFrame !== null) {
        return;
    }
    mobileTabIndicatorFrame = requestAnimationFrame(() => {
        mobileTabIndicatorFrame = null;
        window.refreshMobileTabIndicator(false);
    });
});

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.refreshIconAnimations());
} else {
    window.refreshIconAnimations();
}

document.addEventListener('livewire:init', () => {
    Livewire.hook('morphed', ({ el }) => {
        window.closeTooltips();
        window.initTooltips(el);
    });
    Livewire.hook('commit', ({ succeed, fail }) => {
        succeed(() => window.Modal.release());
        fail(() => window.Modal.release());
    });
    // Zwolnij instancje tooltipów zanim Livewire podmieni <body>. Stare elementy
    // wciąż są w DOM, więc dispose() usuwa je z mapy Bootstrapa i kasuje listenery
    // Poppera. Bez tego każda nawigacja wycieka odłączone drzewo DOM i aktywne
    // listenery scroll/resize na window — strona tnie się coraz bardziej.
    document.addEventListener('livewire:navigating', () => {
        window.disposeTooltips();
    });
    document.addEventListener('livewire:navigated', () => {
        window.closeTooltips();
        window.initTooltips();
        window.refreshIconAnimations();
    });
});
